const PedidoCompraSituacao = Object.freeze({
  PENDENTE: 'N',
  CONTAGEM: 'C',
  ENVIADO: 'E',
  RECEBIDO: 'R',
  ATENDIDO: 'A'
})

export const PedidoCompraSituacaoLabel = Object.freeze({
  N: 'PENDENTE',
  C: 'CONTAGEM',
  E: 'ENVIADO',
  R: 'RECEBIDO',
  A: 'ATENDIDO'
})

/** Pedido ainda editável (pendente ou só contagem), alinhado ao sistema novo. */
export function isPedidoCompraEditavel(situacao) {
  const code = normalizePedidoCompraSituacao(situacao)
  return !code ||
    code === PedidoCompraSituacao.PENDENTE ||
    code === PedidoCompraSituacao.CONTAGEM
}

/** Legado `F` (não recebido) — exibir/tratar como enviado. */
export function normalizePedidoCompraSituacaoExibicao(situacao) {
  const code = normalizePedidoCompraSituacao(situacao)
  if (code === 'F') return PedidoCompraSituacao.ENVIADO
  return code || PedidoCompraSituacao.PENDENTE
}

/** Enviado ao Bling aguardando confirmação do número (E ou R legado sem número). */
export function isPedidoCompraEnviadoAguardandoNumero(situacao, numero) {
  const code = normalizePedidoCompraSituacaoExibicao(situacao)
  return code === PedidoCompraSituacao.ENVIADO ||
    (code === PedidoCompraSituacao.RECEBIDO && !numero)
}

export function normalizePedidoCompraSituacao(situacao) {
  if (situacao == null || situacao === '') return ''
  return String(situacao).trim().toUpperCase()
}

export function getPedidoCompraSituacaoLabel(situacao) {
  const code = normalizePedidoCompraSituacaoExibicao(situacao)
  if (!code) return ''
  if (PedidoCompraSituacaoLabel[code]) return PedidoCompraSituacaoLabel[code]
  if (PedidoCompraSituacao[code]) {
    return PedidoCompraSituacaoLabel[PedidoCompraSituacao[code]] || ''
  }
  return ''
}

export default PedidoCompraSituacao
